import * as ActionTypes from './types.action';

export const getBrochures = () => ({
  type: ActionTypes.GET_BROCHURES_REQUESTED,
});
